var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid-percent h-100"},_vm._l((_vm.tiles),function(item,index){return _c('div',{key:index,staticClass:"product-item",class:{ empty: !!!item }},[(item)?_c('div',{staticClass:"layer-image-wrapper"},[_c('b-img',{staticClass:"img-fluid w-100 d-block layer-image",attrs:{"src":item.featured_image}})],1):_vm._e()])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02da4ce0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wardrobe/outfits/BoxLayoutListItem.vue
// module id = 6cq5
// module chunks = 0